import { api } from './api';

const VISITOR_KEY = 'zxdata.visitorId';

/** 持久访客标识（按浏览器，localStorage）；用于「今日访客 / 当前在线」去重。非 PII，纯随机。 */
export function getVisitorId(): string {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) {
      const rnd =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      v = rnd.replace(/-/g, '').slice(0, 32);
      localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch {
    return 'anon';
  }
}

// 站点行为埋点（fire-and-forget，失败静默，绝不打扰用户）。
// 走主 api 实例：登录态会带 user_id，匿名则无（后端 optionalUser 处理）。
export const analytics = {
  view: (code: string) => {
    void api.post('/events/view', { code }).catch(() => {});
  },
  taobao: (opts: { datasetCode?: string; groupCode?: string }) => {
    void api.post('/events/taobao', opts).catch(() => {});
  },
  ping: (visitorId: string) => {
    void api.post('/events/ping', { visitorId }).catch(() => {});
  },
};
